import {
  Injector,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { SalesForceChatService } from './salesforce-chat.service';
import { DOCUMENT } from '@angular/common';

export function initSalesForceService(
  injector: Injector,
  document: Document,
): () => void {
  return () => {
    const scriptEl = document.createElement('script');
    scriptEl.id = 'salesforce-chat';
    scriptEl.type = 'text/javascript';
    scriptEl.src = 'https://service.force.com/embeddedservice/5.0/esw.min.js';
    scriptEl.defer = true;
    document.head.appendChild(scriptEl);

    const chatService = injector.get(SalesForceChatService);
    chatService.init();
  };
}

@NgModule({
  providers: [
    SalesForceChatService,
    provideAppInitializer(() => {
      const initializerFn = initSalesForceService(
        inject(Injector),
        inject<Document>(DOCUMENT),
      );
      return initializerFn();
    }),
  ],
})
export class SalesForceChatModule {}
